/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConsignorDeliveryNoteBundlesArrayV3 } from '../../models/consignor-delivery-note-bundles-array-v-3';
import { DeliveryNoteBundlesFilterProperties } from '../../models/delivery-note-bundles-filter-properties';
import { KeyType } from '../../models/key-type';
import { SortType } from '../../models/sort-type';

export interface GetConsignorDeliveryNoteBundlesV3$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;

/**
 * Array of organization site keys to fetch data from (max 10). If provided, overrides the path parameter.
 */
  organizationSiteKeys?: Array<KeyType>;

/**
 * Maximum number of items to return
 */
  limit?: number;

/**
 * Number of items to skip
 */
  offset?: number;

/**
 * Sort direction (asc or desc)
 */
  sort?: SortType;

/**
 * Field to sort by for bundles
 */
  sortBy?: 'dateCreated' | 'checkoutDate' | 'dateClosed' | 'name' | 'bundleNumber' | 'consignorLoadCarrierExchange' | 'status' | 'consignorName' | 'consigneeName' | 'carrierName' | 'discrepancies' | 'palletTickets';

/**
 * Field to filter consignor delivery note bundles by
 */
  filterProperty?: DeliveryNoteBundlesFilterProperties;

/**
 * Value to filter by (partial match)
 */
  filterValue?: string;

/**
 * Filter for not closed items only (bundles, tours, delivery notes)
 */
  filterNotClosed?: boolean;

/**
 * If true, only return bundles where at least one delivery note has a discrepancy (normal or fine). Uses the bundle.discrepancies flag for efficient filtering.
 */
  filterOnlyDiscrepancies?: boolean;
}

export function getConsignorDeliveryNoteBundlesV3(http: HttpClient, rootUrl: string, params: GetConsignorDeliveryNoteBundlesV3$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsignorDeliveryNoteBundlesArrayV3>> {
  const rb = new RequestBuilder(rootUrl, getConsignorDeliveryNoteBundlesV3.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.query('organizationSiteKeys', params.organizationSiteKeys, {});
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
    rb.query('sort', params.sort, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('filterProperty', params.filterProperty, {});
    rb.query('filterValue', params.filterValue, {});
    rb.query('filterNotClosed', params.filterNotClosed, {});
    rb.query('filterOnlyDiscrepancies', params.filterOnlyDiscrepancies, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConsignorDeliveryNoteBundlesArrayV3>;
    })
  );
}

getConsignorDeliveryNoteBundlesV3.PATH = '/organization-sites/{organizationSiteKey}/consignor/delivery-note-bundles';
